var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"socket-state",class:_vm.state},[_c('div',{staticClass:"round"}),(_vm.show_text)?_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.human_text))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }